"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5776],{

/***/ 5644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ Breadcrumbs; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/link.js
var next_link = __webpack_require__(58804);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var src = __webpack_require__(45628);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var lib_styles_src = __webpack_require__(52203);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-page-container-virtual-6ffaf0ab98/1/packages/component-page-container/src/index.ts + 1 modules
var component_page_container_src = __webpack_require__(53000);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-typography-virtual-537720fdd1/1/packages/component-typography/src/index.ts + 2 modules
var component_typography_src = __webpack_require__(91371);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-breadcrumbs-virtual-70524e0357/1/packages/component-breadcrumbs/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  max-width: 100vw;\n  overflow-x: hidden;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  width: 100%;\n  max-height: 57px;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  padding: 15px 0;\n  background-color: ",
        ";\n  transition: all 0.3s;\n  @media screen and (max-width: 895px) {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  p {\n    height: 100%;\n    margin-bottom: 5px;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 1px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  margin: 2px 10px;\n  svg {\n    path {\n      stroke-width: 3px;\n    }\n  }\n  @media screen and (max-width: ",
        "px) {\n    svg {\n      margin-bottom: 5px;\n    }\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}




const ScrollableContainer = (0,styled_components_browser_cjs["default"])(component_page_container_src/* PageContainer */._).withConfig({
    componentId: "sc-cde8cdbc-0"
})(_templateObject());
const Wrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-cde8cdbc-1"
})(_templateObject1(), lib_styles_src/* theme.palette.white.main */.rS.palette.white.main);
const BreadWrapper = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-cde8cdbc-2"
})(_templateObject2());
const BreadContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-cde8cdbc-3"
})(_templateObject3());
const BreadLink = (0,styled_components_browser_cjs["default"])(component_typography_src/* PMedium */.aW).withConfig({
    componentId: "sc-cde8cdbc-4"
})(_templateObject4(), lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark);
const Seperator = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-cde8cdbc-5"
})(_templateObject5(), lib_styles_src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-breadcrumbs-virtual-70524e0357/1/packages/component-breadcrumbs/src/breadcrumbs.tsx






const Breadcrumbs = (param)=>{
    let { breadcrumbs  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContainer, {
            flexDirection: "row",
            justifyContent: "flex-start",
            offsetNav: false,
            children: breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map((bread, index)=>{
                const key = index;
                const breadTitle = bread.title;
                const breadHref = bread.url;
                const selected = breadcrumbs.length - 1;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: breadTitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BreadWrapper, {
                        children: [
                            Boolean(key) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Seperator, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src.ArrowRightIcons, {
                                    iconColor: lib_styles_src/* theme.palette.blue.dark */.rS.palette.blue.dark,
                                    size: 12
                                })
                            }),
                            bread.disabled === true || bread.url == undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadLink, {
                                    selected: selected === key,
                                    children: breadTitle
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: breadHref !== null && breadHref !== void 0 ? breadHref : "#",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadLink, {
                                    selected: selected === key,
                                    children: breadTitle
                                })
                            })
                        ]
                    })
                }, key);
            })
        })
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-component-breadcrumbs-virtual-70524e0357/1/packages/component-breadcrumbs/src/index.ts



/***/ }),

/***/ 65776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BykoPage; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-styles-virtual-b3f1d479f2/1/packages/lib-styles/src/index.ts + 18 modules
var src = __webpack_require__(52203);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/context.ts

const BykoPageContext = (0,react.createContext)(null);
const useBykoPageContext = ()=>{
    const value = (0,react.useContext)(BykoPageContext);
    if (value == null) {
        throw new Error("Incorrect usage of BykoPageContext");
    }
    return value;
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-booking-section-virtual-2837f2c92b/1/packages/component-booking-section/src/index.ts + 3 modules
var component_booking_section_src = __webpack_require__(15702);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-page-container-virtual-6ffaf0ab98/1/packages/component-page-container/src/index.ts + 1 modules
var component_page_container_src = __webpack_require__(53000);
// EXTERNAL MODULE: ../../.yarn/__virtual__/styled-components-virtual-29066d9421/0/cache/styled-components-npm-5.3.5-88e3937b59-05a664dfe4.zip/node_modules/styled-components/dist/styled-components.browser.cjs.js
var styled_components_browser_cjs = __webpack_require__(33982);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 88px;\n  @media screen and (max-width: ",
        "px) {\n    height: 56px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: ",
        ";\n  @media screen and (max-width: 1079px) {\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}


const HeaderPad = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5d0b63f7-0"
})(_templateObject(), src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);
const ContentDivider = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5d0b63f7-1"
})(_templateObject1(), (props)=>props.small ? "88px" : "120px", (props)=>props.small ? "56px" : "80px");
const Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-5d0b63f7-2"
})(_templateObject2());

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/divider.tsx



const Divider = (param)=>{
    let { small =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentDivider, {
        small: small
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/content-section-booking.tsx





// eslint-disable-next-line unused-imports/no-unused-vars
const ContentSectionBooking = (_content)=>{
    if (_content.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
        flexDirection: "column",
        offsetNav: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_booking_section_src/* BookingSection */.a, {})
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-content-section-image-tiles-virtual-f05c5d4c6c/1/packages/component-content-section-image-tiles/src/index.ts + 5 modules
var component_content_section_image_tiles_src = __webpack_require__(55313);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/content-section-image-tiles.tsx





const ContentSectionImageTilesBlock = (content)=>{
    const tiles = (0,react.useMemo)(()=>{
        const images = [];
        content.images.forEach((image, index)=>{
            images.push({
                alt: image.alt,
                id: index,
                image: image.jpeg,
                size: "medium"
            });
        });
        return images;
    }, [
        content.images
    ]);
    if (content.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
        flexDirection: "column",
        offsetNav: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_content_section_image_tiles_src/* ContentSectionImageTiles */.Q, {
                size: "medium",
                tiles: tiles
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-content-section-photo-album-virtual-c9ba725c15/1/packages/component-content-section-photo-album/src/index.ts + 5 modules
var component_content_section_photo_album_src = __webpack_require__(26057);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/content-section-photo-gallery.tsx




const ContentSectionPhotoGalleryBlock = (content)=>{
    if (content.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_content_section_photo_album_src/* ContentSectionPhotoAlbum */.S, {
                photos: content.images
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-one-virtual-2e8d1d81ce/1/packages/component-content-section-variant-one/src/index.ts + 2 modules
var component_content_section_variant_one_src = __webpack_require__(42484);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-datocms-virtual-837b2c28ad/0/cache/react-datocms-npm-3.0.14-a51adbb015-0afbb276d8.zip/node_modules/react-datocms/dist/esm/StructuredText/index.js + 5 modules
var StructuredText = __webpack_require__(45265);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-icons-virtual-412b14e947/1/packages/lib-icons/src/index.ts + 181 modules
var lib_icons_src = __webpack_require__(45628);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/icon.tsx



const getIcon = (param)=>{
    let { icon  } = param;
    return lib_icons_src[icon];
};
const Icon = (param)=>{
    let { icon  } = param;
    const Component = useMemo(()=>{
        return icons[icon];
    }, [
        icon
    ]);
    if (!Component) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Component, {});
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/use-paragraph.tsx





const useParagraphValue = (param)=>{
    let { title: heading , textBlockContent , headingUnderlineColor , icon , introText , actionButton  } = param;
    const paragraph = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredText/* StructuredText */.rZ, {
            data: textBlockContent
        });
    }, [
        textBlockContent
    ]);
    const headingDecoration = (0,react.useMemo)(()=>{
        return icon ? getIcon({
            icon: icon
        }) : null;
    }, [
        icon
    ]);
    return {
        actionButton,
        heading,
        paragraph,
        headingDecoration,
        headingUnderlineColor,
        introText: introText !== null && introText !== void 0 ? introText : null
    };
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/content-section1.tsx






const ContentSection1 = (content)=>{
    const paragraphProps = useParagraphValue(content.textBlockContent);
    if (content.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
        flexDirection: "column",
        offsetNav: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_content_section_variant_one_src/* ContentSectionVariantOne */.$, {
                mirrorY: content.mirrorY,
                primaryImage: content.image,
                ...paragraphProps
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-two-virtual-15163bdbdb/1/packages/component-content-section-variant-two/src/index.ts + 2 modules
var component_content_section_variant_two_src = __webpack_require__(79463);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/content-section2.tsx






const ContentSection2 = (content)=>{
    const paragraphProps = useParagraphValue(content.textBlockContent);
    const { decorativeImageOne , decorativeImageTwo , decorativeImageThree  } = (0,react.useMemo)(()=>{
        if (!content.images) {
            return {
                decorativeImageOne: null,
                decorativeImageTwo: null,
                decorativeImageThree: null
            };
        }
        var ref, ref1, ref2;
        return {
            decorativeImageOne: (ref = content.images[0]) !== null && ref !== void 0 ? ref : null,
            decorativeImageTwo: (ref1 = content.images[1]) !== null && ref1 !== void 0 ? ref1 : null,
            decorativeImageThree: (ref2 = content.images[2]) !== null && ref2 !== void 0 ? ref2 : null
        };
    }, [
        content.images
    ]);
    if (content.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
        flexDirection: "column",
        offsetNav: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_content_section_variant_two_src/* ContentSectionVariantTwo */.M, {
                decorativeImageOne: decorativeImageOne,
                decorativeImageThree: decorativeImageThree,
                decorativeImageTwo: decorativeImageTwo,
                primaryImage: content.primaryImage,
                ...paragraphProps
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-three-virtual-19d885276b/1/packages/component-content-section-variant-three/src/index.ts + 2 modules
var component_content_section_variant_three_src = __webpack_require__(99670);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/content-section3.tsx






const ContentSection3 = (content)=>{
    const paragraphProps = useParagraphValue(content.textBlockContent);
    const { decorativeImageOne , decorativeImageTwo , decorativeImageThree  } = (0,react.useMemo)(()=>{
        if (!content.images) {
            return {
                decorativeImageOne: null,
                decorativeImageTwo: null,
                decorativeImageThree: null
            };
        }
        var ref, ref1, ref2;
        return {
            decorativeImageOne: (ref = content.images[0]) !== null && ref !== void 0 ? ref : null,
            decorativeImageTwo: (ref1 = content.images[1]) !== null && ref1 !== void 0 ? ref1 : null,
            decorativeImageThree: (ref2 = content.images[2]) !== null && ref2 !== void 0 ? ref2 : null
        };
    }, [
        content.images
    ]);
    if (content.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
        flexDirection: "column",
        offsetNav: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_content_section_variant_three_src/* ContentSectionVariantThree */.r, {
                decorativeImageOne: decorativeImageOne,
                decorativeImageThree: decorativeImageThree,
                decorativeImageTwo: decorativeImageTwo,
                mirrorY: content.mirrorY,
                ...paragraphProps
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-four-virtual-15c0ed80e6/1/packages/component-content-section-variant-four/src/index.ts + 5 modules
var component_content_section_variant_four_src = __webpack_require__(98986);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/use-bullet.tsx

const useBulletValue = (param)=>{
    let { title , intro , content  } = param;
    const paragraph = useParagraphValue(intro);
    const itemSection = {
        ...paragraph,
        itemSection: {
            title: title,
            items: content
        }
    };
    return itemSection;
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/content-section4.tsx






const ContentSection4 = (content)=>{
    const { ...paragraphProps } = useBulletValue(content.bulletBlockContent);
    const { decorativeImageOne , decorativeImageTwo  } = (0,react.useMemo)(()=>{
        return {
            decorativeImageOne: content.primaryImages[0],
            decorativeImageTwo: content.primaryImages[1]
        };
    }, [
        content.primaryImages
    ]);
    var _images;
    const tagImages = (0,react.useMemo)(()=>(_images = content.images) !== null && _images !== void 0 ? _images : [], [
        content.images
    ]);
    if (content.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
        flexDirection: "column",
        offsetNav: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_content_section_variant_four_src/* ContentSectionVariantFour */.N, {
                decorativeImageOne: decorativeImageOne,
                decorativeImageTwo: decorativeImageTwo,
                mirrorY: content.mirrorY,
                tagImageOne: tagImages[0],
                tagImageTwo: tagImages[1],
                ...paragraphProps
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-five-virtual-773febb0c4/1/packages/component-content-section-variant-five/src/index.ts + 2 modules
var component_content_section_variant_five_src = __webpack_require__(77075);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/use-list.tsx





const getListItem = (value)=>{
    const icon = value.icon ? getIcon({
        icon: value.icon
    }) : null;
    const paragraph = /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredText/* StructuredText */.rZ, {
        data: value.text
    });
    return {
        id: value.id,
        title: value.title,
        paragraph,
        icon,
        number: !icon ? value.id : null
    };
};
const useList = (value)=>{
    return (0,react.useMemo)(()=>{
        return value.map((item)=>getListItem(item));
    }, [
        value
    ]);
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/content-section5.tsx







const ContentSection5 = (content)=>{
    const paragraph = useParagraphValue(content.textBlockContent);
    const textRows = useList(content.listBlockContent);
    const { decorativeImageOne  } = (0,react.useMemo)(()=>{
        return {
            decorativeImageOne: content.primaryImage
        };
    }, [
        content.primaryImage
    ]);
    if (content.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
        flexDirection: "column",
        offsetNav: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_content_section_variant_five_src/* ContentSectionVariantFive */.j, {
                decorativeImageOne: decorativeImageOne,
                mirrorY: content.mirrorY,
                textRows: textRows,
                ...paragraph
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {})
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-content-section-variant-six-virtual-ba430bdf6d/1/packages/component-content-section-variant-six/src/index.ts + 2 modules
var component_content_section_variant_six_src = __webpack_require__(11473);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/content-section6.tsx







const ContentSection6 = (content)=>{
    const paragraphProps = useParagraphValue(content.textBlockContent);
    if (content.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
        flexDirection: "column",
        offsetNav: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_content_section_variant_six_src/* ContentSectionVariantSix */.V, {
                    mirrorX: content.mirrorX,
                    primaryImage: content.image,
                    ...paragraphProps
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-seven-virtual-461dbe8dea/1/packages/component-content-section-variant-seven/src/index.ts + 2 modules
var component_content_section_variant_seven_src = __webpack_require__(86165);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/content-section7.tsx






const getCard = (value)=>(index, name)=>{
        if (!value) {
            return {};
        }
        const content = value[index];
        if (!content) {
            return {};
        }
        return {
            ["".concat(name, "Label")]: content.title,
            ["".concat(name, "Image")]: content.jpeg,
            ["".concat(name, "Link")]: content.link
        };
    };
const ContentSection7 = (content)=>{
    const paragraphProps = useParagraphValue(content.textBlockContent);
    const cardProps = (0,react.useMemo)(()=>{
        const fn = getCard(content.images);
        return {
            ...fn(0, "cardOne"),
            ...fn(1, "cardTwo"),
            ...fn(2, "cardThree"),
            ...fn(3, "cardFour")
        };
    }, [
        content.images
    ]);
    if (content.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
        flexDirection: "column",
        offsetNav: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_content_section_variant_seven_src/* ContentSectionVariantSeven */.C, {
                mirrorY: content.mirrorY,
                primaryImage: content.primaryImage,
                ...cardProps,
                ...paragraphProps
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-content-section-variant-eight-virtual-ecb8360025/1/packages/component-content-section-variant-eight/src/index.ts + 2 modules
var component_content_section_variant_eight_src = __webpack_require__(24844);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/content-section8.tsx






const ContentSection8 = (content)=>{
    const paragraphProps = useParagraphValue(content.textBlockContent);
    const smallImageOne = (0,react.useMemo)(()=>{
        if (content.images && content.images.length >= 1) {
            return content.images[0];
        }
        return undefined;
    }, [
        content.images
    ]);
    const smallImageTwo = (0,react.useMemo)(()=>{
        if (content.images && content.images.length >= 2) {
            return content.images[1];
        }
        return undefined;
    }, [
        content.images
    ]);
    if (content.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
        flexDirection: "column",
        offsetNav: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_content_section_variant_eight_src/* ContentSectionEight */.Q, {
                decorativeImageOne: content.primaryImage,
                mirrorX: content.mirrorY,
                smallImageOne: smallImageOne,
                smallImageTwo: smallImageTwo,
                ...paragraphProps
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-content-section-variant-nine-virtual-3e34b29b90/1/packages/component-content-section-variant-nine/src/index.ts + 2 modules
var component_content_section_variant_nine_src = __webpack_require__(63925);
// EXTERNAL MODULE: ../../packages/types-utils/src/index.ts + 3 modules
var types_utils_src = __webpack_require__(71612);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/content-section9.tsx







const content_section9_getCard = (value)=>(index)=>{
        if (!value) {
            return null;
        }
        const content = value[index];
        if (!content) {
            return null;
        }
        return {
            label: content.title,
            image: content.jpeg,
            link: content.link
        };
    };
const ContentSection9 = (content)=>{
    const paragraphProps = useParagraphValue(content.textBlockContent);
    const cardProps = (0,react.useMemo)(()=>{
        if (!content.images) {
            return [];
        }
        const fn = content_section9_getCard(content.images);
        return content.images.map((_e, i)=>{
            return fn(i);
        }).filter(types_utils_src/* isNotNull */.K0);
    }, [
        content.images
    ]);
    if (content.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
        flexDirection: "column",
        offsetNav: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_content_section_variant_nine_src/* ContentSectionNine */.v, {
                cards: cardProps,
                mirrorX: content.mirrorY,
                ...paragraphProps
            })
        ]
    });
};

// EXTERNAL MODULE: ../../packages/component-content-section-files/src/index.ts + 2 modules
var component_content_section_files_src = __webpack_require__(1147);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/content-sectionfiles.tsx






const ContentSectionFiles = (content)=>{
    const tabCollection = (0,react.useMemo)(()=>{
        return content.fileBlock.map((e)=>{
            const collection = e.files.map((file)=>{
                return {
                    id: file.id,
                    key: file.filename,
                    filePath: file.url
                };
            });
            var _title;
            return {
                label: (_title = e.title) !== null && _title !== void 0 ? _title : "",
                icon: e.icon ? getIcon({
                    icon: e.icon
                }) : null,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_content_section_files_src/* ContentSectionFiles.Item */.K.Item, {
                    collection: collection
                })
            };
        });
    }, [
        content.fileBlock
    ]);
    if (content.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
        flexDirection: "column",
        offsetNav: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_content_section_files_src/* ContentSectionFiles */.K, {
                tabCollection: tabCollection
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-product-card-virtual-69967d117c/1/packages/component-product-card/src/index.ts + 22 modules
var component_product_card_src = __webpack_require__(64549);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-product-slider-section-virtual-37024fa6cf/1/packages/component-product-slider-section/src/index.ts + 2 modules
var component_product_slider_section_src = __webpack_require__(36355);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-api-products-virtual-81752d2989/1/packages/lib-api-products/src/index.ts + 130 modules
var lib_api_products_src = __webpack_require__(68825);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-algolia-virtual-7767b18cc0/1/packages/lib-algolia/src/index.ts + 7 modules
var lib_algolia_src = __webpack_require__(5283);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-lib-utils-virtual-08ae943915/1/packages/lib-utils/src/index.ts + 19 modules
var lib_utils_src = __webpack_require__(65582);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-hooks-auth-next-virtual-a089da2ab7/1/packages/hooks-auth-next/src/index.ts + 15 modules
var hooks_auth_next_src = __webpack_require__(54516);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/product-section.tsx
/* eslint-disable react-perf/jsx-no-new-object-as-prop */ 









const ProductSection = (content)=>{
    var ref;
    const { activeMembership  } = (0,hooks_auth_next_src/* useAuth */.aC)();
    const idList = (0,react.useMemo)(()=>{
        const list = [];
        content.products.forEach((product)=>{
            const ids = product.productId.split("-");
            const actualId = ids[ids.length - 1];
            if (actualId) {
                list.push(actualId);
            }
        });
        return list;
    }, [
        content.products
    ]);
    const paragraph = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredText/* StructuredText */.rZ, {
            data: content.paragraph
        });
    }, [
        content.paragraph
    ]);
    const { data  } = (0,lib_algolia_src/* useAlgoliaProductQuery */.zC)({
        productIds: idList
    });
    const pricedProducts = data === null || data === void 0 ? void 0 : (ref = data.hits) === null || ref === void 0 ? void 0 : ref.filter((p)=>{
        return !(p.salesAvailability === "custom" || p.salesAvailability === "display" || isRentalProduct(p) || !(activeMembership === null || activeMembership === void 0 ? void 0 : activeMembership.account.hasContract) && p.salesAvailability === "by_contract");
    }).map((p)=>p.id);
    const { prices  } = (0,lib_api_products_src/* useProductLowestPrices */.BY)(pricedProducts);
    const prods = (0,lib_utils_src/* ensureList */.fL)(data === null || data === void 0 ? void 0 : data.hits.map(lib_api_products_src/* algoliaHitToProduct */.Qo));
    const collection = (0,react.useMemo)(()=>{
        const productCards = prods.map((product, index)=>{
            if (isRentalProduct(product)) {
                var ref, ref1;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_product_card_src/* ProductRentCard */.iJ, {
                    addedLabel: "Leiguvara",
                    algoliaInsights: {
                        eventName: "Rent Card Clicked",
                        index: (data === null || data === void 0 ? void 0 : data.index) || "",
                        queryID: (data === null || data === void 0 ? void 0 : data.queryID) || "",
                        objectIDs: [
                            (product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.sku) || ""
                        ],
                        positions: [
                            index + 1
                        ]
                    },
                    listIndex: index,
                    product: product,
                    smallMobileCard: true
                }, product.id);
            } else {
                var ref2;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(component_product_card_src/* ProductStandardCard */.ZL, {
                    algoliaInsights: {
                        eventName: "Click ProductCard",
                        index: (data === null || data === void 0 ? void 0 : data.index) || "",
                        queryID: (data === null || data === void 0 ? void 0 : data.queryID) || "",
                        objectIDs: [
                            (product === null || product === void 0 ? void 0 : product.id.toString()) || ""
                        ],
                        positions: [
                            index + 1
                        ]
                    },
                    analyticsSectionId: "front-page-product-slider",
                    listIndex: index,
                    lowestPriceSKU: (prices === null || prices === void 0 ? void 0 : prices[product.id]) !== undefined ? Object.keys((ref2 = prices === null || prices === void 0 ? void 0 : prices[product.id]) !== null && ref2 !== void 0 ? ref2 : {})[0] : undefined,
                    prices: prices === null || prices === void 0 ? void 0 : prices[product.id],
                    product: product,
                    smallMobileCard: true
                }, product.id);
            }
        });
        return productCards;
    }, [
        prices,
        prods,
        data
    ]);
    if (content.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_product_slider_section_src/* ProductSliderSection */.Z, {
                collection: collection,
                heading: content.heading,
                paragraph: paragraph
            })
        ]
    });
};
function isRentalProduct(product) {
    let isRental = false;
    try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        isRental = product.attributes.typeParent.includes("Leigumarka\xf0ur");
    } catch (e) {
    // silent
    }
    return isRental;
}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/content-klaviyo-embed.tsx
/* eslint-disable react-perf/jsx-no-new-object-as-prop */ /* eslint-disable react/no-danger */ 



const ContentKlaviyoEmbed = (_content)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
        flexDirection: "column",
        offsetNav: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "klaviyo-embed-container",
                dangerouslySetInnerHTML: {
                    __html: _content.embedCode
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-content-section-html-block-virtual-283fe47e85/1/packages/component-content-section-html-block/src/index.ts + 1 modules
var component_content_section_html_block_src = __webpack_require__(17961);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/content-section-html.tsx
function content_section_html_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function content_section_html_templateObject() {
    const data = content_section_html_taggedTemplateLiteral([
        "\n  height: 100%;\n  iframe {\n    overflow: hidden;\n    height: 100%;\n    border: none;\n    outline: none;\n  }\n"
    ]);
    content_section_html_templateObject = function() {
        return data;
    };
    return data;
}






const IframeContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-3685d812-0"
})(content_section_html_templateObject());
const ContentSectionHtml = (_content)=>{
    if (_content.hidden) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(component_page_container_src/* PageContainer */._, {
        flexDirection: "column",
        offsetNav: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_content_section_html_block_src/* ContentSectionHtmlBlock */.x, {
                content: _content
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/index.tsx




















// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ContentSectionParse = {
    ContentSection1: ContentSection1,
    ContentSection2: ContentSection2,
    ContentSection3: ContentSection3,
    ContentSection4: ContentSection4,
    ContentSection5: ContentSection5,
    ContentSection6: ContentSection6,
    ContentSection7: ContentSection7,
    ContentSection8: ContentSection8,
    ContentSection9: ContentSection9,
    ContentSectionFiles: ContentSectionFiles,
    ContentSectionProduct: ProductSection,
    ImageTilesBlock: ContentSectionImageTilesBlock,
    PhotoGalleryBlock: ContentSectionPhotoGalleryBlock,
    SimplybookmeBlock: ContentSectionBooking,
    HtmlBlock: ContentSectionHtml,
    KlaviyoFormEmbed: ContentKlaviyoEmbed
};
const Content = ()=>{
    const { content  } = useBykoPageContext();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: content.map((value)=>{
            const Component = ContentSectionParse[value.type];
            if (!Component) {
                return null;
            }
            if (value.type === "PhotoGalleryBlock") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                    ...value
                }, value.id);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* MotionWrapper */.Lb, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                    ...value
                })
            }, value.id);
        })
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-cff1f1d108/0/cache/next-npm-13.0.0-0d765f7d5e-7b5c847287.zip/node_modules/next/head.js
var head = __webpack_require__(30844);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/header.tsx




const Header = ()=>{
    const { seo  } = useBykoPageContext();
    const tags = (0,react.useMemo)(()=>{
        var _alt;
        const image = seo.image ? {
            "og:image": {
                content: seo.image.jpeg
            },
            "og:image:type": {
                content: "image/jpeg"
            },
            "og:image:width": {
                content: seo.image.width.toString()
            },
            "og:image:height": {
                content: seo.image.height.toString()
            },
            "og:image:alt": {
                content: (_alt = seo.image.alt) !== null && _alt !== void 0 ? _alt : ""
            }
        } : {};
        return {
            "og:type": {
                content: "website"
            },
            "og:description": {
                content: seo.description
            },
            "og:title": {
                content: seo.title
            },
            "twitter:site": {
                content: "@bykoehf"
            },
            ...image
        };
    }, [
        seo.description,
        seo.title,
        seo.image
    ]);
    const title = seo.title === "BYKO" ? seo.title : "BYKO - ".concat(seo.title);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: seo.description,
                name: "description"
            }, "description"),
            Object.keys(tags).map((e)=>{
                var ref;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    content: (ref = tags[e]) === null || ref === void 0 ? void 0 : ref.content,
                    property: e
                }, e);
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-breadcrumbs-virtual-70524e0357/1/packages/component-breadcrumbs/src/index.ts + 2 modules
var component_breadcrumbs_src = __webpack_require__(5644);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-component-dato-image-virtual-b95002e71f/1/packages/component-dato-image/src/index.ts + 7 modules
var component_dato_image_src = __webpack_require__(44674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@byko-text-block-variant-one-virtual-a533df4313/1/packages/component-text-block-variant-one/src/index.ts + 4 modules
var component_text_block_variant_one_src = __webpack_require__(71667);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/top-banner-variant-one/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: grid;\n  width: 100%;\n  max-width: ",
        "px;\n  border: 8px solid ",
        ";\n  margin-top: 16px;\n  margin-right: auto;\n  margin-left: auto;\n  background-color: ",
        ";\n  ",
        "\n\n  ",
        "\n  \n  ",
        "\n  \n  ",
        "\n\n  ",
        "\n\n  ",
        "\n  \n  ",
        "\n  \n  ",
        "\n\n  ",
        "\n  ",
        "\n\n  grid-template-columns: 0.75fr 0.75fr 1fr;\n  grid-template-rows: auto 333px;\n\n  @media screen and (max-width: ",
        "px) {\n    ",
        "\n\n    ",
        "\n    \n    ",
        "\n    grid-template-columns: 1fr 1fr;\n  }\n"
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  padding: 96px 112px;\n  border: 8px solid ",
        ";\n  background-color: ",
        ";\n  grid-area: text;\n  transition: padding 300ms;\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 48px 24px;\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 64px 48px;\n  }\n\n  @media screen and (min-width: ",
        "px) and (max-width: ",
        "px) {\n    padding: 80px 56px;\n  }\n\n  &::before {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 32px;\n    background-color: ",
        ';\n    content: "";\n    transition: width 300ms;\n    @media screen and (min-width: ',
        "px) and (max-width: ",
        "px) {\n      width: 16px;\n    }\n  }\n\n  p {\n    max-width: 544px;\n  }\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  height: 100%;\n  border: 8px solid ",
        ";\n  grid-area: primary;\n  img {\n    object-fit: cover !important;\n  }\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 317px;\n  border: 8px solid ",
        ";\n  grid-area: secondarya;\n  object-fit: cover;\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n    height: 200px;\n  }\n  img {\n    object-fit: cover !important;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 317px;\n  border: 8px solid ",
        ";\n  grid-area: secondaryb;\n  object-fit: cover;\n  @media screen and (max-width: ",
        "px) {\n    width: 100%;\n    height: 200px;\n  }\n  img {\n    object-fit: cover !important;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}


const styles_Container = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-117b4c09-0"
})(styles_templateObject(), src/* gridTheme.maxContentWidth */.k.maxContentWidth, src/* theme.palette.white.main */.rS.palette.white.main, src/* theme.palette.white.main */.rS.palette.white.main, (props)=>props.mirrorX && props.mirrorY && props.secondaryImageCount === 2 ? 'grid-template-areas:\n      "primary secondarya secondaryb "\n      "primary text text";' : "", (props)=>!props.mirrorX && props.mirrorY && props.secondaryImageCount === 2 ? 'grid-template-areas:\n      "primary text text"\n      "primary secondarya secondaryb";' : "", (props)=>props.mirrorX && !props.mirrorY && props.secondaryImageCount === 2 ? 'grid-template-areas:\n      "secondarya secondaryb primary"\n      "text text primary";' : "", (props)=>!props.mirrorX && !props.mirrorY && props.secondaryImageCount === 2 ? 'grid-template-areas:\n      "text text primary"\n      "secondarya secondaryb primary";' : "", (props)=>props.mirrorX && props.mirrorY && props.secondaryImageCount === 1 ? 'grid-template-areas:\n      "primary secondarya secondarya "\n      "primary text text";' : "", (props)=>!props.mirrorX && props.mirrorY && props.secondaryImageCount === 1 ? 'grid-template-areas:\n      "primary text text"\n      "primary secondarya secondarya";' : "", (props)=>props.mirrorX && !props.mirrorY && props.secondaryImageCount === 1 ? 'grid-template-areas:\n      "secondarya secondarya primary"\n      "text text primary";' : "", (props)=>!props.mirrorX && !props.mirrorY && props.secondaryImageCount === 1 ? 'grid-template-areas:\n      "text text primary"\n      "secondarya secondarya primary";' : "", (props)=>props.mirrorY && props.secondaryImageCount === 0 ? 'grid-template-areas: \n      "primary text text"\n      "primary text text";' : "", (props)=>!props.mirrorY && props.secondaryImageCount === 0 ? 'grid-template-areas: \n      "text text primary"\n      "text text primary";' : "", src/* gridTheme.breakpoints.sm */.k.breakpoints.sm, (props)=>props.secondaryImageCount === 0 ? 'grid-template-areas: \n          "text text"\n          "primary primary";' : "", (props)=>props.secondaryImageCount === 1 ? 'grid-template-areas: \n          "text text"\n          "primary primary"\n          "secondarya secondarya";' : "", (props)=>props.secondaryImageCount === 2 ? 'grid-template-areas: \n          "text text"\n          "primary primary"\n          "secondarya secondaryb"\n          "secondarya secondaryb";' : "");
const TextBlockContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-117b4c09-1"
})(styles_templateObject1(), src/* theme.palette.white.main */.rS.palette.white.main, src/* theme.palette.blue.dark */.rS.palette.blue.dark, src/* gridTheme.container.minWidth.xs */.k.container.minWidth.xs, src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s, src/* gridTheme.container.minWidth.sm */.k.container.minWidth.sm, src/* gridTheme.container.maxWidth.sm */.k.container.maxWidth.sm, src/* gridTheme.container.minWidth.md */.k.container.minWidth.md, src/* gridTheme.container.maxWidth.md */.k.container.maxWidth.md, src/* theme.palette.yellow.main */.rS.palette.yellow.main, src/* gridTheme.container.minWidth.xs */.k.container.minWidth.xs, src/* gridTheme.container.maxWidth.s */.k.container.maxWidth.s);
const PrimaryImageContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-117b4c09-2"
})(styles_templateObject2(), src/* theme.palette.white.main */.rS.palette.white.main);
const SecondaryImageAContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-117b4c09-3"
})(_templateObject3(), src/* theme.palette.white.main */.rS.palette.white.main, src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);
const SecondaryImageBContainer = styled_components_browser_cjs["default"].div.withConfig({
    componentId: "sc-117b4c09-4"
})(_templateObject4(), src/* theme.palette.white.main */.rS.palette.white.main, src/* gridTheme.breakpoints.sm */.k.breakpoints.sm);

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/content/top-banner-variant-one/index.tsx






const TopBannerVariantOne = (param)=>{
    let { heading , paragraph , primaryImage , secondaryImageA , secondaryImageB , mirrorXAxis =false , mirrorYAxis =false , headingDecoration , introText , actionButton  } = param;
    const secondaryImageCount = (0,react.useMemo)(()=>{
        return Number(Boolean(secondaryImageA)) + Number(Boolean(secondaryImageB));
    }, [
        secondaryImageA,
        secondaryImageB
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Container, {
        mirrorX: mirrorXAxis,
        mirrorY: mirrorYAxis,
        secondaryImageCount: secondaryImageCount,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBlockContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_text_block_variant_one_src/* TextBlockVariantOne */.p, {
                    buttonColor: "whiteButton",
                    buttonLabel: actionButton === null || actionButton === void 0 ? void 0 : actionButton.text,
                    buttonLink: actionButton === null || actionButton === void 0 ? void 0 : actionButton.link,
                    darkMode: true,
                    heading: heading,
                    headingDecoration: headingDecoration,
                    introText: introText,
                    maxColumns: 1,
                    paragraph: paragraph
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_dato_image_src/* DatoImage */.jt, {
                    ...primaryImage,
                    priority: true
                })
            }),
            secondaryImageA ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecondaryImageAContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_dato_image_src/* DatoImage */.jt, {
                        ...secondaryImageA
                    }),
                    " "
                ]
            }) : null,
            secondaryImageB ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecondaryImageBContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_dato_image_src/* DatoImage */.jt, {
                        ...secondaryImageB
                    }),
                    " "
                ]
            }) : null
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/top.tsx








const Top = ()=>{
    const { breadcrumbs , top: { images , content , mirrorXAxis , mirrorYAxis  }  } = useBykoPageContext();
    if (!images[0]) {
        throw new Error("Invalid image");
    }
    const top__topPrimaryImage = images[0];
    var ref;
    const top__secondaryImageA = (ref = images[1]) !== null && ref !== void 0 ? ref : null;
    var ref1;
    const top__secondaryImageB = (ref1 = images[2]) !== null && ref1 !== void 0 ? ref1 : null;
    const top__headingDecoration = content.icon ? getIcon({
        icon: content.icon
    }) : null;
    const top__introText = content.introText;
    const top__paragraph = (0,react.useMemo)(()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredText/* StructuredText */.rZ, {
            data: content.textBlockContent
        });
    }, [
        content
    ]);
    // blocking links for all breadcrumbs except first and last
    const filteredBreadcrumbs = (0,react.useMemo)(()=>{
        return breadcrumbs.map((breadcrumb, index)=>{
            return {
                ...breadcrumb,
                disabled: breadcrumb.canBeNavigatedToInMegamenu == false || index == breadcrumbs.length - 1
            };
        });
    }, [
        breadcrumbs
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_breadcrumbs_src/* Breadcrumbs */.O, {
                breadcrumbs: filteredBreadcrumbs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* MotionWrapper */.Lb, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBannerVariantOne, {
                    actionButton: content.actionButton,
                    heading: content.title,
                    headingDecoration: top__headingDecoration,
                    introText: top__introText,
                    mirrorXAxis: mirrorXAxis,
                    mirrorYAxis: mirrorYAxis,
                    paragraph: top__paragraph,
                    primaryImage: top__topPrimaryImage,
                    secondaryImageA: top__secondaryImageA,
                    secondaryImageB: top__secondaryImageB
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/byko-page.tsx







const BykoPage = (param)=>{
    let { page  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BykoPageContext.Provider, {
        value: page,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Top, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {})
        ]
    });
};

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@byko-scene-byko-page-virtual-5ca33819a6/1/packages/scene-byko-page/src/index.ts



/***/ })

}]);